<template>
    <div class="content">
        <el-button @click="getFileData">获取上传文件</el-button>
        <WebUpload
            :fileNumLimit="fileNumLimit"
            :fileSize="fileSize"
            :chunkSize="chunkSize"
            :uploadSuffixUrl="uploadSuffixUrl"
            :options="options"
            :fileListData="tableData"
        > </WebUpload>
    </div>
</template>
<script>
import WebUpload from './common/upload/WebUpload'

export default {
    name: 'webupload',
    components:{
        WebUpload
    },
    data() {
        return {
            uploader:{},
            uploadBtnDisabled:false,
            uploadStaus:"el-icon-upload",
            tableData:[],//显示集合
            fileNumLimit:10,//文件总数
            fileSize:100*1024*1024*1024,//默认上传文件大小
            chunkSize:2*1024*1024,//默认文件片段
            uploadSuffixUrl:"http://localhost:18288/",
            options:{
                //允许上传的文件
                fileType:"doc,docx,pdf,xls,xlsx,ppt,pptx,txt,gif,jpg,jpeg,bmp,png,rar,zip,mp4,avi,dmg,sql,7z,apk,ipa,gz,rpm,pkg,ovpn",
                fileUploadUrl:"upload/upload",//上传地址
                mergeChunksUrl:"upload/merge",//合并文件请求地址
                headers:{
                    token: localStorage.getItem('token')
                }
            }
        }
    },
    methods: {
        getFileData(){
            console.log("tableData:",this.tableData);
            console.log("tableData len:",this.tableData.length);
            var fListData = this.tableData;
            fListData.forEach(function (item) {
                console.log("item:",item)
            })
        }
    }
}
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/Upload.vue